import { USER_LOADED, LOGIN_SUCCESS, LOGOUT, AUTH_ERROR, AUTH_ERROR_DRIVER, USER_NOORGANIZATION } from "../actions/types";
import setToken from '../utility/setToken';
import { encryptString, generateKey } from '../utility/utils';

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: false,
  loading: true,
  user: null,
  roles: null,
  organizationID: localStorage.getItem('organizationID')
};

export default function auth(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case USER_LOADED:
      (async () => {

        if (payload.licenseType !== undefined && payload.licenseType !== null) {
          // const key = await generateKey();
          // console.log(payload.licenseType.name);
          // const { encryptedData, iv } = await encryptString(payload.licenseType.name, key);
          // localStorage.setItem("licenseType", JSON.stringify({ encryptedData, iv }));
          localStorage.setItem("licenseType", payload.licenseType.name);
        }
      })();
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload.data,
        roles: payload.roles,
        //organizationID: payload.organizationID
      };
    case USER_NOORGANIZATION:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload.data,
      }
    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload.token);
      localStorage.setItem("organizationID", payload.data.organizationMembers[0].organizationID);
      localStorage.setItem("organizationText", payload.data.organizationMembers[0].name);
      localStorage.setItem("alias", payload?.alias);
      console.log(payload.noHp)
      localStorage.setItem("driver", payload?.noHp?payload.noHp:null);
      // console.log(localStorage)
      // setToken(payload.token);
      return {
        ...state,
        token: payload,
        isAuthenticated: true,
        loading: false,
      };
    case AUTH_ERROR_DRIVER:
      if (window.innerWidth <= 768 && localStorage.getItem("driver")) {
        alert("Network Error");
        // Return current state without clearing localStorage.
        return { ...state, loading: false };
      } else {
        // Normal behavior: clear storage except fcm.
        const fcm = localStorage.getItem("fcm");
        window.localStorage.clear();
        localStorage.setItem("fcm", fcm);
        setToken(null, null);
        return {
          ...state,
          token: null,
          user: null,
          isAuthenticated: false,
          loading: false,
        };
      }
    case AUTH_ERROR:
    case LOGOUT:
      const fcm = localStorage.getItem("fcm");
      window.localStorage.clear();
      localStorage.setItem("fcm", fcm);
      setToken(null, null);
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        loading: false,
      };
    default:
      return state;
  }
}